import { OverlayRef } from '@angular/cdk/overlay';

export class GalleryLightboxOverlayRef {

  constructor(private overlayRef: OverlayRef) { }

  close(): void {
    this.overlayRef.dispose();
  }
}
